<template>
    <div class="footer-wrapper">
        <div class="footer">
            <div class="footer-elements">
                <div class="element">
                    <router-link class="cta" to="/#projects">
                        ⇠ Back to Projects
                    </router-link> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Logo from '@/components/Logo.vue'
    export default {
        components: {
            Logo
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/base.scss';
    .footer-wrapper {
        position: relative;
        bottom: 0;
        left: 0;
        width: 100vw;
        z-index: 100;
        background: #192A34;
    }
    .footer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin: 0 auto;
        max-width: 1280px;
        margin: 2.5rem auto 0 auto;
        padding: 3rem 0 2.5rem 0;
    }

    .footer-logo {
        margin-left: -.65rem;
    }

    .footer-elements {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        margin: 1rem 0 2.5rem 0;
        .element {
            margin-bottom: .85rem;
            a {
                padding: .75rem;
            }
        }
    }

    
</style>